/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import { FC } from 'react';
import s from './Breadcrumbs.module.scss';

type BreadcrumbsProps = {
  titleName?: string;
  crumbs: Array<BreadcrumbsArrayConfiguration>;
};

export type BreadcrumbsArrayConfiguration = {
  name: string;
  path: string;
};

const Breadcrumbs: FC<BreadcrumbsProps> = ({ titleName = '', crumbs }) => {
  if (crumbs.length <= 1) {
    return null;
  }

  return (
    <div className={`${s.breadcrumb}`}>
      <h2 className={`${s.breadcrumb__title} p-0`}>{titleName}</h2>
      <ol className={`${s.breadcrumb__source}`}>
        {crumbs.map(
          ({ name, path }: BreadcrumbsArrayConfiguration, key: number) =>
            key + 1 === crumbs.length ? (
              <li
                key={path}
                className={`breadcrumb-item ${s.breadcrumb__source__item} `}
              >
                <strong className={`${s.breadcrumb__source__item__active} `}>
                  {name}
                </strong>
              </li>
            ) : (
              <li
                key={path}
                className={`breadcrumb-item ${s.breadcrumb__source__item} `}
              >
                <span>{name}</span>
              </li>
            )
        )}
      </ol>
    </div>
  );
};

export default Breadcrumbs;
